import { createAsyncThunk } from "@reduxjs/toolkit";
import { callApi } from "../../services/api";
import { setUsers } from "../reducers/sms";
import { asyncAlertError } from "./common";
import { setLocalAdminLoading } from "../reducers/common";

export const asyncCreateSmsUser = createAsyncThunk(
  "user/sms/create",
  async (body, { dispatch, getState }) => {
    try {
      dispatch(setLocalAdminLoading(true));

      const { token } = getState().auth;

      const res = await callApi({
        path: `admin/sms/user`,
        method: "POST",
        body,
        token,
      });

      if (res.success) {
        // dispatch(asyncAlertSuccess("User Successfully Created!"));
        return { success: true };
      }

      dispatch(asyncAlertError(res.message));
      return { success: false };
    } catch (error) {
      dispatch(asyncAlertError(error.message));
      return { success: false };
    } finally {
      dispatch(setLocalAdminLoading(false));
    }
  }
);

export const asyncGetAllSmsUser = createAsyncThunk(
  "user/sms/list",
  async (_, { dispatch, getState }) => {
    try {
      dispatch(setLocalAdminLoading(true));

      const token = getState().auth.token;

      const res = await callApi({
        path: "admin/sms/user",
        method: "GET",
        token,
      });

      if (res.success) {
        dispatch(setUsers(res.data));
        return { success: true };
      }

      dispatch(asyncAlertError(res.message));
      return { success: false };
    } catch (error) {
      dispatch(asyncAlertError(error.message));
      return { success: false };
    } finally {
      dispatch(setLocalAdminLoading(false));
    }
  }
);

export const asyncUpdateSmsUser = createAsyncThunk(
  "user/sms/update",
  async ({ id, ...body }, { dispatch, getState }) => {
    try {
      dispatch(setLocalAdminLoading(true));

      const { token } = getState().auth;

      const res = await callApi({
        path: `admin/sms/user/${id}`,
        method: "PUT",
        body,
        token,
      });

      if (res.success) {
        // dispatch(asyncAlertSuccess("User Successfully Updated!"));
        return { success: true };
      }

      dispatch(asyncAlertError(res.message));
      return { success: false };
    } catch (error) {
      dispatch(asyncAlertError(error.message));
      return { success: false };
    } finally {
      dispatch(setLocalAdminLoading(false));
    }
  }
);

export const asyncBanSmsUser = createAsyncThunk(
  "user/sms/ban",
  async ({ id }, { dispatch, getState }) => {
    try {
      dispatch(setLocalAdminLoading(true));

      const { token } = getState().auth;
      const res = await callApi({
        path: `admin/sms/ban/${id}`,
        method: "PUT",
        token,
      });

      if (res.success) {
        // dispatch(
        //   asyncAlertSuccess(
        //     `User Successfully ${res.data.ban ? "Banned" : "UnBanned"}!`
        //   )
        // );
        return { success: true };
      }

      dispatch(asyncAlertError(res.message));
      return { success: false };
    } catch (error) {
      dispatch(asyncAlertError(error.message));
      return { success: false };
    } finally {
      dispatch(setLocalAdminLoading(false));
    }
  }
);

export const asyncDeleteSmsUser = createAsyncThunk(
  "user/sms/delete",
  async ({ id, ...body }, { dispatch, getState }) => {
    try {
      dispatch(setLocalAdminLoading(true));

      const { token } = getState().auth;

      const res = await callApi({
        path: `admin/sms/user/${id}`,
        method: "DELETE",
        body,
        token,
      });

      if (res.success) {
        // dispatch(asyncAlertSuccess("User Successfully Deleted!"));
        return { success: true };
      }

      dispatch(asyncAlertError(res.message));
      return { success: false };
    } catch (error) {
      dispatch(asyncAlertError(error.message));
      return { success: false };
    } finally {
      dispatch(setLocalAdminLoading(false));
    }
  }
);
